import { FunctionOpenInNewTab } from "radium-omnibus";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../context/Context.Language";
import {
  SYMBOL_CURRENCY,
  TEXT_ABOUT_US,
  TEXT_BANGKOK,
  TEXT_CONTACT_US,
  TEXT_FAQ,
  TEXT_GLOSSARY,
  TEXT_GO_TO_BASKET,
  TEXT_LISENCE,
  TEXT_LISENCE_TITLE,
  TEXT_LOCATIONS,
  TEXT_OUR_SERVICE,
  TEXT_PATTAYA,
  TEXT_PRICING,
  TEXT_PRIVACY_POLICY,
  TEXT_REDUCE_REUSE_RECYCLE,
  TEXT_TERM_AND_CONDITION,
  WWW,
} from "../../utils/useConstants";
import {
  ICON_FACEBOOK,
  ICON_GERMANY,
  ICON_IG,
  ICON_LINE,
  ICON_MESSENGER_WHITE,
  ICON_WHATSAPP_WHITE,
  ICON_YOUTUBE,
} from "../../utils/useIcons";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_BG_BLACK_FOOTER,
  STYLE_BG_WHITE_GOOGLE_MAP,
  STYLE_BORDER_FOOTER,
  STYLE_CLIENT_WITH_LOGO_FOOTER,
  STYLE_GRID_FOOTER,
  STYLE_HOVER_WHITE,
  STYLE_ICON_SOCAIL_FOOTER,
  STYLE_ICON_SOCIAL,
  STYLE_IMG_FOOTER,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_MENU_FOOTER,
  STYLE_PADDING_READING,
  STYLE_PADDING_WINDOWS,
  STYLE_PARENT_REDUCE_REUSE_RECYCLE,
  STYLE_TEXT_GRAY_80,
  STYLE_TEXT_GRAY_80_UNDERLINE_FOOTER,
  STYLE_TEXT_LOGO_FOOTER,
  STYLE_TEXT_REDUCE_REUSE_RECYCLE,
  STYLE_TEXT_WHITE_FOOTER,
  STYLE_TEXT_WHITE_LOCATION_FOOTER,
  STYLE_TEXT_WHITE_LOCATION_FOOTER_NO_UNDERLINE,
} from "../../utils/useStyle";

import { GoogleMapMain } from "../googleMap/GoogleMap.Main";
import { ContextCart } from "../../context/Context.Cart";
import BasketCalculatePrice from "../../pages/basket/function/Basket.CalculatePrice";
import { ButtonScrollObserver } from "../../utils/useObserver";
import { StoreSameDayService } from "../../utils/useStorage";
import { AwaitComponent } from "../../utils/useAutosuzeTextArea";

const onClickMiddle = (to, isNotCompleteProfile, navigate) => {
  if (isNotCompleteProfile) {
    return;
  } else {
    navigate(to);
  }
};

const LogoSection = ({ isNotCompleteProfile }) => {
  const navigate = useNavigate();

  return (
    <div className=" pb-0 md:pb-8 my-auto">
      {/* <a href={WWW}> */}
      <img
        onClick={() => {
          if (isNotCompleteProfile) {
            return;
          } else {
            navigate("/");
            // window.location.href = WWW;
          }
        }}
        src="/images/logo.png"
        className={`mx-auto md:mx-0 h-[42px] md:h-auto xl:h-14 mb-2 xl:mb-6 cursor-pointer my-auto`}
      />
      {/* </a> */}
    </div>
  );
};

const DrawerFixedShowProgram = ({ refContent, config }) => {
  const { cart } = React.useContext(ContextCart);
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const sameDayService = StoreSameDayService((state) => state.sameDayService);

  if (cart?.length > 0) {
    return (
      <div
        ref={refContent}
        onClick={() => navigate("/Basket")}
        className={` w-full pt-4 pb-10 md:pt-8 md:pb-8 shadowbottomh-[160px] bg-white z-50 `}
      >
        <div className={` ${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_READING}`}>
          <button
            className={`${
              language === "TH"
                ? " text-sm-th xl:text-base-th "
                : " text-sm xl:text-base "
            } w-full bg-laundry-primary-blue p-4 md:py-2 md:px-6 rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue  hover:bg-laundry-gray-80 hover:order-blue hover:text-white duration-300  focus:outline-none h-h_50 md:h-input flex justify-center gap-1 items-center `}
          >
            <div>{TEXT_GO_TO_BASKET[language]}</div> -
            <div>
              <span className="font-NotoSansThai mr-[0.25px]">
                {SYMBOL_CURRENCY}
              </span>
              {BasketCalculatePrice(
                null,
                cart,
                sameDayService,
                config?.same_day_price
              )}
            </div>
          </button>
        </div>
      </div>
    );
  } else {
    return <React.Fragment />;
  }
};

const MenuSection = ({ isNotCompleteProfile }) => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);

  return (
    <React.Fragment>
      <div className={STYLE_MENU_FOOTER}>
        <div
          className={`${STYLE_TEXT_WHITE_FOOTER(
            language
          )} md:w-menu_width_footer `}
        >
          <div
            onClick={() =>
              onClickMiddle("/OurServices", isNotCompleteProfile, navigate)
            }
            className={STYLE_HOVER_WHITE}
          >
            {/* <a
              href={
                isNotCompleteProfile
                  ? "#"
                  : language === "TH"
                  ? `${WWW}/OurServices/TH`
                  : `${WWW}/OurServices`
              }
            >
              {TEXT_OUR_SERVICE[language]}
            </a> */}
            {TEXT_OUR_SERVICE[language]}
          </div>

          <div
            onClick={() =>
              onClickMiddle("/Pricing", isNotCompleteProfile, navigate)
            }
            className={STYLE_HOVER_WHITE}
          >
            {/* <a
              href={
                isNotCompleteProfile
                  ? "#"
                  : language === "TH"
                  ? `${WWW}/Pricing/TH`
                  : `${WWW}/Pricing`
              }
            >
              {TEXT_PRICING[language]}
            </a> */}
            {TEXT_PRICING[language]}
          </div>
          <div
            onClick={() =>
              onClickMiddle("/FAQ", isNotCompleteProfile, navigate)
            }
            className={STYLE_HOVER_WHITE}
          >
            {/* <a
              href={
                isNotCompleteProfile
                  ? "#"
                  : language === "TH"
                  ? `${WWW}/FAQ/TH`
                  : `${WWW}/FAQ`
              }
            >
              {TEXT_FAQ[language]}
            </a> */}
            {TEXT_FAQ[language]}
          </div>
        </div>

        <div
          className={`${STYLE_TEXT_WHITE_FOOTER(
            language
          )} mt-2 md:mt-0 md:w-w_90`}
        >
          {/* <div
            onClick={() =>
              onClickMiddle("/Glossary", isNotCompleteProfile, navigate)
            }
            className={STYLE_HOVER_WHITE}
          >
            {TEXT_GLOSSARY[language]}
          </div> */}
          <div
            onClick={() =>
              onClickMiddle("/AboutUs", isNotCompleteProfile, navigate)
            }
            className={STYLE_HOVER_WHITE}
          >
            {" "}
            {/* <a
              href={
                isNotCompleteProfile
                  ? "#"
                  : language === "TH"
                  ? `${WWW}/AboutUs/TH`
                  : `${WWW}/AboutUs`
              }
            >
              {TEXT_ABOUT_US[language]}
            </a> */}
            {TEXT_ABOUT_US[language]}
          </div>
          <div
            onClick={() =>
              onClickMiddle("/ContactUs", isNotCompleteProfile, navigate)
            }
            className={STYLE_HOVER_WHITE}
          >
            {/* <a
              href={
                isNotCompleteProfile
                  ? "#"
                  : language === "TH"
                  ? `${WWW}/ContactUs/TH`
                  : `${WWW}/ContactUs`
              }
            >
              {TEXT_CONTACT_US[language]}
            </a> */}
            {TEXT_CONTACT_US[language]}
          </div>
        </div>
        <div className={` mt-7 space-y-2 md:space-y-2.5 md:w-20 md:mt-0 `}>
          <div
            className={`${
              language === "TH"
                ? " text-sm-th md:text-base-th "
                : " text-sm md:text-base "
            } text-laundry-primary-blue font-semibold hover:none`}
          >
            {TEXT_LOCATIONS[language]}
          </div>
          <div
            // onClick={() =>
            //   onClickMiddle("/Bangkok", isNotCompleteProfile, navigate)
            // }

            className={`${STYLE_TEXT_WHITE_LOCATION_FOOTER_NO_UNDERLINE(
              language
            )} `}
          >
            {/* <a
              href={
                isNotCompleteProfile
                  ? "#"
                  : language === "TH"
                  ? `${WWW}/Bangkok/TH`
                  : `${WWW}/Bangkok`
              }
            >
              {TEXT_BANGKOK[language]}
            </a> */}
            {TEXT_BANGKOK[language]}
          </div>
          <div
            // onClick={() => navigate("/Pattaya")}
            // onClick={() =>
            //   onClickMiddle("/Pattaya", isNotCompleteProfile, navigate)
            // }
            className={`${STYLE_TEXT_WHITE_LOCATION_FOOTER_NO_UNDERLINE(
              language
            )} `}
          >
            {/* <a
              href={
                isNotCompleteProfile
                  ? "#"
                  : language === "TH"
                  ? `${WWW}/Pattaya/TH`
                  : `${WWW}/Pattaya`
              }
            >
              {TEXT_PATTAYA[language]}
            </a> */}
            {TEXT_PATTAYA[language]}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const ClientSection = () => {
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className={STYLE_TEXT_LOGO_FOOTER(language)}>
      <div>{TEXT_LISENCE_TITLE[language]}</div>
      <img src="/images/boschlogo.svg" className=" h-h_25 md:h-4 lg:h-h_30 " />
      <ICON_GERMANY />
    </div>
  );
};

const SocialSection = () => {
  return (
    <div className="flex justify-center items-center md:pl-0 lg:pl-10 xl:pl-[80px] gap-3 md:gap-2 lg:gap-3 xl:gap-4 h-[41px] md:h-10   ">
      {/* <ICON_YOUTUBE
        className={`${STYLE_ICON_SOCIAL} `}
        onClick={() => {
          FunctionOpenInNewTab("https://www.youtube.com/@mylaundrythai/");
        }}
      /> */}
      <div className={`w-7`}></div>
      <ICON_FACEBOOK
        className={STYLE_ICON_SOCIAL}
        onClick={() => {
          FunctionOpenInNewTab("https://www.facebook.com/mylaundrythai");
        }}
      />
      <ICON_IG
        className={STYLE_ICON_SOCIAL}
        onClick={() => {
          FunctionOpenInNewTab("https://www.instagram.com/mylaundrythai/");
        }}
      />
      <div className="  border-r border-laundry-gray-80 h-full "></div>
      <ICON_LINE
        className={STYLE_ICON_SOCIAL}
        onClick={() => {
          FunctionOpenInNewTab("https://page.line.me/?accountId=mylaundrythai");
        }}
      />
      {/* <ICON_TIKTOK className={STYLE_ICON_SOCIAL} />
       */}
      <ICON_MESSENGER_WHITE
        className={STYLE_ICON_SOCAIL_FOOTER}
        onClick={() => {
          FunctionOpenInNewTab("http://m.me/mylaundrythai");
        }}
      />
      <ICON_WHATSAPP_WHITE
        className={STYLE_ICON_SOCAIL_FOOTER}
        onClick={() => {
          FunctionOpenInNewTab("http://wa.me/66925165458");
        }}
      />
    </div>
  );
};

const ShowGoogleMap = [
  "/",
  "/TH",
  "/FAQ",
  "/FAQ/TH",
  "/ContactUs",
  "/ContactUs/TH",
  "/AboutUs",
  "/AboutUs/TH",
  "/Pricing",
  "/Pricing/TH",
  "/PrivacyNotice",
  "/PrivacyNotice/TH",
  "/TermsAndConditions",
  "/TermsAndConditions/TH",
  "/Bangkok",
  "/Bangkok/TH",
  "/Pattaya",
  "/Pattaya/TH",
];

const Footer = ({ programs, config }) => {
  const [loaded, setLoaded] = React.useState(false);
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  const { cart } = React.useContext(ContextCart);
  const isMobile = useIsMobile();
  const location = useLocation();

  React.useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  }, []);

  const isNotCompleteProfile = location?.pathname === "/CompleteProfile";

  if (!loaded) {
    return <div></div>;
  }
  return (
    <React.Fragment>
      <div>
        {ShowGoogleMap.includes(location.pathname) && <GoogleMapMain />}

        {location.pathname === "/" && (
          <AwaitComponent>
            <ButtonScrollObserver
              render={<DrawerFixedShowProgram config={config?.EN} />}
            />
          </AwaitComponent>
        )}

        <div className={`${STYLE_BG_BLACK_FOOTER}`}>
          <div
            className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_WINDOWS}`}
          >
            <div className={STYLE_GRID_FOOTER}>
              <LogoSection isNotCompleteProfile={isNotCompleteProfile} />
              <div className=" col-span-3 md:pl-[115px] lg:pl-[183px]">
                <MenuSection
                  programs={programs}
                  isNotCompleteProfile={isNotCompleteProfile}
                />
              </div>
            </div>
            <div className={STYLE_BORDER_FOOTER}></div>
            {isMobile ? (
              <div className={STYLE_CLIENT_WITH_LOGO_FOOTER}>
                <ClientSection />
                {/* {(language === language) === "TH" ? (
                <img
                  src="/images/recycle_thai.png"
                  className={STYLE_IMG_FOOTER}
                />
              ) : (
                <img src="/images/recycle.png" className={STYLE_IMG_FOOTER} />
              )} */}
                <div className={STYLE_PARENT_REDUCE_REUSE_RECYCLE}>
                  <img
                    src="/images/recycle_logo.svg"
                    className={STYLE_IMG_FOOTER}
                  />
                  <div className={STYLE_TEXT_REDUCE_REUSE_RECYCLE(language)}>
                    {" "}
                    {TEXT_REDUCE_REUSE_RECYCLE[language]}
                  </div>
                </div>
                <SocialSection />
              </div>
            ) : (
              <div className={STYLE_CLIENT_WITH_LOGO_FOOTER}>
                <ClientSection />
                <div className={STYLE_PARENT_REDUCE_REUSE_RECYCLE}>
                  <img
                    src="/images/recycle_logo.svg"
                    className={STYLE_IMG_FOOTER}
                  />
                  <div className={STYLE_TEXT_REDUCE_REUSE_RECYCLE(language)}>
                    {" "}
                    {TEXT_REDUCE_REUSE_RECYCLE[language]}
                  </div>
                </div>

                <SocialSection />
              </div>
            )}
            {isMobile ? (
              <div
                className={`flex flex-col justify-center items-center mt-4 gap-2 `}
              >
                <div className=" flex gap-5">
                  <div
                    className={STYLE_TEXT_GRAY_80_UNDERLINE_FOOTER(language)}
                    // onClick={() => navigate("/TermsAndConditions")}
                    onClick={() =>
                      onClickMiddle(
                        "/TermsAndConditions",
                        isNotCompleteProfile,
                        navigate
                      )
                    }
                  >
                    {/* <a
                      href={
                        isNotCompleteProfile
                          ? "#"
                          : language === "TH"
                          ? `${WWW}/TermsAndConditions/TH`
                          : `${WWW}/TermsAndConditions`
                      }
                    >
                      {TEXT_TERM_AND_CONDITION[language]}
                    </a> */}
                    {TEXT_TERM_AND_CONDITION[language]}
                  </div>
                  <div
                    className={STYLE_TEXT_GRAY_80_UNDERLINE_FOOTER(language)}
                    // onClick={() => navigate("/PrivacyNotice")}
                    onClick={() =>
                      onClickMiddle(
                        "/PrivacyNotice",
                        isNotCompleteProfile,
                        navigate
                      )
                    }
                  >
                    {/* <a
                      href={
                        isNotCompleteProfile
                          ? "#"
                          : language === "TH"
                          ? `${WWW}/PrivacyNotice/TH`
                          : `${WWW}/PrivacyNotice`
                      }
                    >
                      {TEXT_PRIVACY_POLICY[language]}
                    </a> */}
                    {TEXT_PRIVACY_POLICY[language]}
                  </div>
                </div>
                <div className={STYLE_TEXT_GRAY_80(language)}>
                  {TEXT_LISENCE}
                </div>
              </div>
            ) : (
              <div className={`flex justify-between items-center mt-5`}>
                <div className={STYLE_TEXT_GRAY_80(language)}>
                  {TEXT_LISENCE}
                </div>
                <div className=" flex gap-6.5">
                  <div
                    className={STYLE_TEXT_GRAY_80_UNDERLINE_FOOTER(language)}
                    // onClick={() => navigate("/TermsAndConditions")}
                    onClick={() =>
                      onClickMiddle(
                        "/TermsAndConditions",
                        isNotCompleteProfile,
                        navigate
                      )
                    }
                  >
                    {/* <a
                      href={
                        isNotCompleteProfile
                          ? "#"
                          : language === "TH"
                          ? `${WWW}/TermsAndConditions/TH`
                          : `${WWW}/TermsAndConditions`
                      }
                    >
                      {TEXT_TERM_AND_CONDITION[language]}
                    </a> */}
                    {TEXT_TERM_AND_CONDITION[language]}
                  </div>
                  <div
                    className={STYLE_TEXT_GRAY_80_UNDERLINE_FOOTER(language)}
                    // onClick={() => navigate("/PrivacyNotice")}
                    onClick={() =>
                      onClickMiddle(
                        "/PrivacyNotice",
                        isNotCompleteProfile,
                        navigate
                      )
                    }
                  >
                    {/* <a
                      href={
                        isNotCompleteProfile
                          ? "#"
                          : language === "TH"
                          ? `${WWW}/PrivacyNotice/TH`
                          : `${WWW}/PrivacyNotice`
                      }
                    >
                      {TEXT_PRIVACY_POLICY[language]}
                    </a> */}
                    {TEXT_PRIVACY_POLICY[language]}
                  </div>
                </div>
              </div>
            )}
            <div id="last-element"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
